import React, { useEffect, useState } from 'react';
import { useUpdateEffect } from 'react-use';
import { Header } from 'semantic-ui-react';
import { redirect } from 'react-router-dom';
import InputsForFindAccounts from '../../components/account/InputsForFindAccounts';
import InputsForResetPW from '../../components/account/InputsForReSetPW';
import SendCodeForFindAccounts from '../../components/account/SendCodeForFindAccounts';
import { trimAll } from '../../utils/common';
import { MAIL_REGEXP, TEL_REGEXP } from '../../utils/validate';

const ReSetPWContainer = props => {
  const {
    select,
    error,
    step,
    userinfo,
    pending,
    hadSent,
    handleChange,
    handleSend,
    handleResend,
    t,
  } = props;
  const [userId, setUserId] = useState(userinfo.userId || '');
  const [email, setEmail] = useState(userinfo.email || '');
  const [tel, setTel] = useState(userinfo.tel || '');
  const [cert, setCert] = useState('');
  const [password, setPassword] = useState(
    userinfo.password || { pw: null, repw: null },
  );
  const [authMethod, setMethod] = useState('tel');

  const userIdInput = {
    key: 'userId',
    label: t('ID.LB'),
    name: 'userId',
    type: 'text',
    disabled: step > 0,
    // value: userId,
    // defaultValue: userinfo && userinfo.userId,
  };

  const emailInput = {
    key: 'email',
    label: t('MAIL.LB'),
    placeholder: t('EMAIL.INPUT.VERIFIED'),
    pattern: MAIL_REGEXP,
    name: 'email',
    type: 'email',
    disabled: step > 0,
    value: email,
    defaultValue: userinfo && userinfo.email,
  };

  const telInput = {
    key: 'tel',
    label: t('TEL.LB'),
    placeholder: t('TEL.INPUT.VERIFIED'),
    pattern: TEL_REGEXP,
    name: 'tel',
    type: 'tel',
    disabled: step > 0,
    value: tel,
    defaultValue: userinfo && userinfo.tel,
  };

  const pwInput = {
    key: 'pw',
    label: t('PW.LB'),
    placeholder: t('FIND.INPUT.PW'),
    name: 'pw',
    type: 'password',
    value: password.pw,
  };
  const repwInput = {
    key: 'repw',
    label: t('PW.CONFIRM'),
    placeholder: t('FIND.INPUT.RE_PW'),
    name: 'repw',
    type: 'password',
    value: password.repw,
  };

  const onChange = e => {
    const changeTarget = e.target.name;
    const changeValue = e.target.value;
    switch (changeTarget) {
      case 'userId':
        setUserId(trimAll(changeValue).toLowerCase());
        break;
      case 'email':
        setEmail(changeValue.trim());
        break;

      case 'tel':
        setTel(changeValue.trim());
        break;
      case 'cert':
        setCert(trimAll(changeValue));
        break;
      case 'pw':
      case 'repw':
        setPassword({ ...password, [changeTarget]: trimAll(changeValue) });
        break;
      default:
        break;
    }
  };

  const onMethodChange = (e, { value: newMethod }) => {
    if (newMethod === 'tel') {
      setEmail('');
    } else {
      setTel('');
    }
    setMethod(newMethod);
  };

  useUpdateEffect(
    () => handleChange({ userId, email, tel, password, cert, authMethod }),
    [userId, email, tel, password, cert, authMethod],
  );

  useEffect(() => (select ? () => {} : redirect('/findAccounts')), [select]);

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      {step === 0 && (
        <InputsForFindAccounts
          {...{
            userIdInput: { ...userIdInput, value: userId },
            emailInput,
            telInput,
            info: t('FIND.MSG.RESET_INFO'),
            msg: error,
            authMethod,
            onMethodChange,
            onChange,
          }}
        />
      )}
      {step === 1 && (
        <SendCodeForFindAccounts
          {...{
            loading: pending,
            userIdInput: {
              ...userIdInput,
              defaultValue: userinfo && userinfo.userId,
            },
            authMethod,
            authInput: authMethod === 'tel' ? telInput : emailInput,
            info: t('FIND.MSG.BE_VERIFY_RESET'),
            msg: error,
            hadSent,
            onChange,
            onSend: handleSend,
            onResend: handleResend,
          }}
        />
      )}
      {step === 2 && (
        <InputsForResetPW
          {...{
            pwInput,
            repwInput,
            info: t('FIND.MSG.INPUT_NEW_PW'),
            onChange,
            msg: error,
          }}
        />
      )}
      {step === 3 && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            margin: 'auto',
          }}
        >
          <Header
            as="h3"
            style={{
              margin: 0,
              padding: '.5rem 5%',
              color: '#565B5B',
              textAlign: 'center',
            }}
          >
            {t('FIND.RESULT.RESET')}
          </Header>
        </div>
      )}
    </div>
  );
};

export default ReSetPWContainer;
